import {toRelativeUrl} from '@okta/okta-auth-js';
import {useOktaAuth} from '@okta/okta-react';
import React, {useEffect} from 'react';
import {Outlet, Navigate} from 'react-router-dom';

const SecureRoute = () => {
  const {authState, oktaAuth} = useOktaAuth();

  useEffect(() => {
    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin
      );
      oktaAuth.setOriginalUri(originalUri);
    }
  }, [oktaAuth, !!authState, authState?.isAuthenticated]);

  if (!authState) {
    return <div>Loading...</div>;
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default SecureRoute;
